export const CharacterData_three = [ 
    {
        name: "Asuka Tatsuki",
        rarity: "3",
        type: "Aqua",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Asuka's-Kioku.webp",
        stats: {
          hp: 6275,
          atk: 2745,
          def: 2046,
          spd: 94
        },
        spatk: {
          name :"Asuka’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% aqua DMG to a single enemy.",
        skill: {
          name: "Leapstrike Slash",
          desc: "Deals 200% aqua DMG to a single enemy. Increases own ATK by 18% (2 turns)."
        },
        ability: {
          name: "Blast",
          desc: "When an enemy is defeated, increases DMG dealt by 18% (2 turns)."
        },
        suppability: {
          name: "Blast",
          desc: "Equipped to Attacker: Increases DMG dealt by 5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases DMG dealt by 8% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Masara Kagami",
        rarity: "3",
        type: "Light",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Masara's-Kioku.webp",
        stats: {
          hp: 6297,
          atk: 2744,
          def: 2038,
          spd: 97
        },
        spatk: {
          name: "Masara’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% light DMG to a single enemy.",
        skill: {
          name: "Cold Edge",
          desc: "Deals 120% light DMG to all enemies. Increases own DMG dealt by 18% (1 turn)."
        },
        ability: {
          name: "Chase",
          desc: "On enemy break, triggers a follow-up attack. Follow-Up Attack: Deals 60% light DMG to all enemies."
        },
        suppability: {
          name: "Assault",
          desc: "Equipped to Light: Increases ATK by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases DMG dealt by 8% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Rika Ayano",
        rarity: "3",
        type: "Flame",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Rika's-Kioku.webp",
        stats: {
          hp: 6236,
          atk: 2750,
          def: 2055,
          spd: 96
        },
        spatk: {
          name: "Rika’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% flame DMG to a single enemy.",
        skill: {
          name: "Cascading Heat",
          desc: "Deals 200% flame DMG to a single enemy. Increases own DMG dealt by 18% (1 turn)."
        },
        ability: {
          name: "Chase",
          desc: "On enemy break, triggers a follow-up attack. Follow-Up Attack: Deals 100% flame DMG to a single enemy."
        },
        suppability: {
          name: "Assault",
          desc: "Equipped to Attacker: Increases ATK by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. Increases follow-up attack DMG dealt by 10%.",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Ashley Taylor",
        rarity: "3",
        type: "Dark",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Ashley's-Kioku.webp",
        stats: {
          hp: 6253,
          atk: 2733,
          def: 2065,
          spd: 95
        },
        spatk: {
          name: "Ashley’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% dark DMG to a single enemy.",
        skill: {
          name: "Bombing Bear",
          desc: "Deals 120% dark DMG to all enemies. Increases own DMG dealt by 18% (1 turn)."
        },
        ability: {
          name: "Chase",
          desc: "On enemy break, triggers a follow-up attack. Follow-Up Attack: Deals 60% dark DMG to all enemies."
        },
        suppability: {
          name: "Assault",
          desc: "Equipped to Dark: Increases ATK by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. Increases follow-up attack DMG dealt by 10%.",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Kush Irina",
        rarity: "3",
        type: "Dark",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Kush's-Kioku.webp",
        stats: {
          hp: 6227,
          atk: 2744,
          def: 2061,
          spd: 96
        },
        spatk: {
          name: "Kush’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% dark DMG to a single enemy.",
        skill: {
          name: "Blade of Conviction",
          desc: "Deals 120% dark DMG to all enemies, and deals 30% dark DMG if own HP 80% or higher."
        },
        ability: {
          name: "Blast Edge",
          desc: "0 Magic at battle start. On DMG dealt to an enemy, grants 1 Magic. At max Magic, increases DMG dealt by 18% and critical rate by 18%. Max 5 Magic."
        },
        suppability: {
          name: "Defense",
          desc: "Equipped to Attacker: Decreases DMG taken by 5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. At max magic, increases critical DMG by 8%.",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Kako Natsume",
        rarity: "3",
        type: "Forest",
        role: "Attacker",
        image: "https://exedra-app-4f335.web.app/images/Kako's-Kioku.webp",
        stats: {
          hp: 6236,
          atk: 2750,
          def: 2051,
          spd: 93
        },
        spatk: 
        {
          name: "Kako’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% forest DMG to a single enemy.",
        skill: {
          name: "Guiding Mark",
          desc: "Deals 170% forest DMG to a single enemy, and if own HP is 50% or higher, also deals 30% forest DMG."
        },
        ability: {
          name: "Blast",
          desc: "On enemy break, increases DMG dealt by 18% (2 turns)."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Attacker: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 10 (2 turns).",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases ATK by 8% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Karin Misono",
        rarity: "3",
        type: "Flame",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Karin's-Kioku.webp",
        stats: {
          hp: 7178,
          atk: 2148,
          def: 2347,
          spd: 114
        },
        spatk: {
          name: "Karin’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% flame DMG to a single enemy.",
        skill: {
          name: "Death Harvest",
          desc: "Deals 160% flame DMG to a single enemy. Increases own break effect by 50% (1 turn)."
        },
        ability: {
          name: "Blast",
          desc: "On enemy break, increases DMG dealt by 18% (2 turns)."
        },
        suppability: {
          name: "Assault",
          desc: "Equipped to Breaker: Increases ATK by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. Increases break effect by 20%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Reira Ibuki",
        rarity: "3",
        type: "Flame",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Reira's-Kioku.webp",
        stats: {
          hp: 7219,
          atk: 2125,
          def: 2355,
          spd: 114
        },
        spatk: {
          name: "Reira’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% flame DMG to a single enemy.",
        skill: {
          name: "Sword of Flame",
          desc: "Deals 130% flame DMG to a single enemy and 100% flame DMG to enemies in proximity."
        },
        ability: {
          name: "Strike",
          desc: "On enemy break, increases critical DMG by 20% (2 turns)."
        },
        suppability: {
          name: "Haste",
          desc: "Equipped to Flame: Increases SPD by 8%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases critical rate by 10% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Seika Kumi",
        rarity: "3",
        type: "Aqua",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Seika's-Kioku.webp",
        stats: {
          hp: 7228,
          atk: 2120,
          def: 2359,
          spd: 111
        },
        spatk: {
          name: "Seika’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% aqua DMG to a single enemy.",
        skill: {
          name: "Aqua Whip",
          desc: "Deals 160% aqua DMG to a single enemy. Increases own break effect by 50% (1 turn)."
        },
        ability: {
          name: "Haste",
          desc: "On enemy break, increases SPD by 18 (2 turns)."
        },
        suppability: {
          name: "Haste",
          desc: "Equipped to Aqua: Increases SPD by 8%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. Break Gauge Depletion+.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Hanna Sarasa",
        rarity: "3",
        type: "Dark",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Hanna's-Kioku.webp",
        stats: {
          hp: 7178,
          atk: 2148,
          def: 2348,
          spd: 113
        },
        spatk: {
          name: "Hanna’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% dark DMG to a single enemy.",
        skill: {
          name: "Accursed Sphere",
          desc: "Deals 160% dark DMG to a single enemy. Increases own SPD by 18% (2 turns)."
        },
        ability: {
          name: "Haste Piercing",
          desc: "Increases break bonus by 40%, and on enemy break, increases SPD by 18 (2 turns)."
        },
        suppability: {
          name: "Haste",
          desc: "Equipped to Breaker: Increases SPD by 8%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Riko Chiaki",
        rarity: "3",
        type: "Light",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Riko's-Kioku.webp",
        stats: {
          hp: 7188,
          atk: 2140,
          def: 2352,
          spd: 114
        },
        spatk: {
          name: "Riko’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% light DMG to a single enemy.",
        skill: {
          name: "Pick of Plenty",
          desc: "Deals 130% light DMG to a single enemy and 100% light DMG to enemies in proximity."
        },
        ability: {
          name: "Haste Breakage",
          desc: "Increases break effect by 40%, and on enemy break, increases SPD by 15 (2 turns)."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Breaker: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. Break Gauge Depletion+.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Meiyui Chun",
        rarity: "3",
        type: "Aqua",
        role: "Breaker",
        image: "https://exedra-app-4f335.web.app/images/Meiyui's-Kioku.webp",
        stats: {
          hp: 7161,
          atk: 2146,
          def: 2353,
          spd: 113
        },
        spatk: {
          name: "Meiyu’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% aqua DMG to a single enemy.",
        skill: {
          name: "Hawk Talon Fist",
          desc: "Deals 160% aqua DMG to a single enemy. Increases own break effect by 40% (1 turn)."
        },
        ability: {
          name: "Haste Piercing",
          desc: "Increases break bonus by 20% and SPD by 18."
        },
        suppability: {
          name: "Assault",
          desc: "Equipped to Aqua: Increase ATK by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. Increases break effect by 30%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, advances action order by 10%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. On maxed enemy break bonus, advances all allies’ action order by 10%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Nanaka Tokiwa",
        rarity: "3",
        type: "Forest",
        role: "Buffer",
        image: "https://exedra-app-4f335.web.app/images/Nanaka's-Kioku.webp",
        stats: {
          hp: 6975,
          atk: 2270,
          def: 2293,
          spd: 116
        },
        spatk: {
          name:"Nanaka’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% forest DMG to a single enemy.",
        skill: {
          name: "Hollyhock",
          desc: "Deals 200% forest DMG to a single enemy. Increases all allies’ DMG dealt by 16% (2 turns)."
        },
        ability: {
          name: "Blast",
          desc: "When an enemy is defeated, increases all allies’ DMG by 15% (2 turns)."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Buffer: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. Increases all allies’ ATK by 8%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 25 (2 turns).",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%."
        }
      },
      {
        name: "Himika Mao",
        rarity: "3",
        type: "Flame",
        role: "Buffer",
        image: "https://exedra-app-4f335.web.app/images/Himika's-Kioku.webp",
        stats: {
          hp: 7001,
          atk: 2232,
          def: 2322,
          spd: 120
        },
        spatk: {
          name: "Himika’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% flame DMG to a single enemy.",
        skill: {
          name: "Lucky Palm",
          desc: "Increases a single ally’s critical rate by 18% (1 turn) and DMG dealt by 18% (1 turn)."
        },
        ability: {
          name: "Haste",
          desc: "If HP 80% or higher, increases SPD by 18%."
        },
        suppability: {
          name: "Haste",
          desc: "Equipped to Buffer: Increases SPD by 8%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. Increases all allies’ critical DMG by 5%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 25 (2 turns).",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Ayame Mikuri",
        rarity: "3",
        type: "Flame",
        role: "Buffer",
        image: "https://exedra-app-4f335.web.app/images/Ayame's-Kioku.webp",
        stats: {
          hp: 7063,
          atk: 2255,
          def: 2278,
          spd: 118
        },
        spatk: {
          name: "Ayame’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% flame DMG to a single enemy.",
        skill: {
          name: "Critical Strike",
          desc: "Increases a single ally’s critical DMG by 30% (2 turns)."
        },
        ability: {
          name: "Blast",
          desc: "On enemy break, increases all allies’ DMG dealt by 15% (2 turns)."
        },
        suppability: {
          name: "Toughness",
          desc: "Equipped to Flame: Increases max HP by 5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. Increases all allies’ critical rate by 10%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 25 (2 turns).",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Natsuki Utsuho",
        rarity: "3",
        type: "Aqua",
        role: "Buffer",
        image: "https://exedra-app-4f335.web.app/images/Natsuki's-Kioku.webp",
        stats: {
          hp: 6962,
          atk: 2259,
          def: 2307,
          spd: 119
        },
        spatk: {
          name: "Natsuki’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% aqua DMG to a single enemy.",
        skill: {
          name: "We Can Do It!",
          desc: "Increases all allies’ ATK by 16% (2 turns), and if own HP 80% or higher, increases DMG dealt by 16% (2 turns)."
        },
        ability: {
          name: "Edge",
          desc: "On enemy break, increases all allies’ critical rate by 15% (2 turns)."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Aqua: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases all allies’ critical DMG by 8% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 5%.",
          4: "Increases HP/ATK/DEF by 2%. At battle start, increases SPD by 25 (2 turns).",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Mito Aino",
        rarity: "3",
        type: "Forest",
        role: "Debuffer",
        image: "https://exedra-app-4f335.web.app/images/Mito's-Kioku.webp",
        stats: {
          hp: 6962,
          atk: 2275,
          def: 2293,
          spd: 116
        },
        spatk: {
          name: "Mito’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% forest DMG to a single enemy.",
        skill: {
          name: "Admonishing Arrow",
          desc: "Deals 160% forest DMG to a single enemy and 120% forest DMG to enemies in proximity. Increases targets’ DMG taken by 6% (2 turns)."
        },
        ability: {
          name: "Haste",
          desc: "Increases SPD by 15, and on DMG dealt by self, increases SPD by 5% (2 turns / Stacks 5 times)."
        },
        suppability: {
          name: "Toughness",
          desc: "Equipped to Debuffer: Increases max HP by 5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. Increases SPD by 5.",
          3: "Increases HP/ATK/DEF by 2%. Increases debuff hit rate by 25%.",
          4: "Increases HP/ATK/DEF by 2%. Increases SPD by 10.",
          5: "Increases HP/ATK/DEF by 2%. Increases debuff hit rate by 25%."
        }
      },
      {
        name: "Hazuki Yusa",
        rarity: "3",
        type: "Light",
        role: "Debuffer",
        image: "https://exedra-app-4f335.web.app/images/Hazuki's-Kioku.webp",
        stats: {
          hp: 7063,
          atk: 2227,
          def: 2307,
          spd: 116
        },
        spatk: {
          name: "Hazuki’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% light DMG to a single enemy.",
        skill: {
          name: "Shock Wave",
          desc: "Decreases a single enemy’s DEF by 15% (3 turns) and removes all target’s buffs."
        },
        ability: {
          name: "Haste Jammer",
          desc: "Increases debuff hit rate by 50%, and if HP 50% or higher, increases SPD by 20."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Debuffer: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. At battle start, advances action order by 10%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, increases all enemies’ DMG taken by 10% (2 turns).",
          3: "Increases HP/ATK/DEF by 2%. Increases debuff hit rate by 25%.",
          4: "Increases HP/ATK/DEF by 2%. Increases SPD by 10.",
          5: "Increases HP/ATK/DEF by 2%. Increases debuff hit rate by 25%."
        }
      },
      {
        name: "Kokoro Awane",
        rarity: "3",
        type: "Light",
        role: "Defender",
        image: "https://exedra-app-4f335.web.app/images/Kokoro's-Kioku.webp",
        stats: {
          hp: 7028,
          atk: 1784,
          def: 2758,
          spd: 87
        },
        spatk: {
          name: "Kokoro’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% light DMG to a single enemy.",
        skill: {
          name: "Pile Strike",
          desc: "Deals 200% light DMG to a single enemy. Applies shield to all allies (20% / 2 times)."
        },
        ability: {
          name: "Guard Haste",
          desc: "At battle start, increases SPD by 100% (2 turns). On taking at least 1 DMG from an enemy attack, increases all allies’ DEF by 4% (2 turns / Stacks 3 times)."
        },
        suppability: {
          name: "Guard",
          desc: "Equipped to Light: Increases DEF by 7.5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. On taking DMG equal to 20% or higher of max HP, restores 10% of own HP.",
          2: "Increases HP/ATK/DEF by 2%. Increases all allies’ DEF by 10%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases DEF by 10%.",
          4: "Increases HP/ATK/DEF by 2%. At battle start, applies shield to self (50% / 1 time).",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases DEF by 10%."
        }
      },
      {
        name: "Yuma Chitose",
        rarity: "3",
        type: "Forest",
        role: "Healer",
        image: "https://exedra-app-4f335.web.app/images/Yuma's-Kioku.webp",
        stats: {
          hp: 8412,
          atk: 1798,
          def: 2296,
          spd: 101
        },
        spatk: {
          name: "Yuma’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% forest DMG to a single enemy.",
        skill: {
          name: "Kitty Care",
          desc: "Restores a single ally’s HP by 18% of user’s HP +100, and removes all debuffs."
        },
        ability: {
          name: "Accele",
          desc: "On enemy break, grants 12 MP to all allies."
        },
        suppability: {
          name: "Toughness",
          desc: "Equipped to Healer: Increases max HP by 5%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. If under 50% HP, increases HP recovery amount by 20%.",
          2: "Increases HP/ATK/DEF by 2%. On enemy break, grants 5 MP to all allies.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases max HP by 2%.",
          4: "Increases HP/ATK/DEF by 2%. Increases max HP by 20%.",
          5: "Increases HP/ATK/DEF by 2%. Increases DMG dealt by 5%."
        }
      },
      {
        name: "Konoha Shizumi",
        rarity: "3",
        type: "Aqua",
        role: "Healer",
        image: "https://exedra-app-4f335.web.app/images/Konoha's-Kioku.webp",
        stats: {
          hp: 8465,
          atk: 1794,
          def: 2278,
          spd: 109
        },
        spatk: {
          name: "Konoha’s Kioku",
          desc: ""
        },
        basicatk: "Deals 100% aqua DMG to a single enemy.",
        skill: {
          name: "Healing Butterflies",
          desc: "Restores all allies’ HP by 8% of user’s HP +73."
        },
        ability: {
          name: "Benefit",
          desc: "Increases HP recovery amount by 20%."
        },
        suppability: {
          name: "Benefit",
          desc: "Equipped to Healer: Increases HP recovery amount by 8%."
        },
        asc: {
          1: "Increases HP/ATK/DEF by 2%. If under 50% HP, increases HP recovery amount by 20%.",
          2: "Increases HP/ATK/DEF by 2%. Increases HP recovery amount by 10%.",
          3: "Increases HP/ATK/DEF by 2%. At battle start, increases max HP by 2%.",
          4: "Increases HP/ATK/DEF by 2%. Increases max HP by 20%.",
          5: "Increases HP/ATK/DEF by 2%. At battle start, increases max HP by 2%."
        }
      }
]